import React, { FC } from 'react';
import { Button, Modal, Tooltip } from 'antd';
import { Close, Receipt } from 'common/svg';
import { IconBackground } from 'common/components/IconBackground';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  disabled?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const PurchaseOrderConfirmModal: FC<IComponentProps> = ({
  open,
  loading,
  disabled,
  onCancel,
  onSubmit,
}) => {
  const handleCancel = () => {
    if (loading) {
      return;
    }

    onCancel();
  };

  return (
    <Modal
      open={open}
      rootClassName="modal"
      width={372}
      centered
      closeIcon={<Close className="icon-gray" />}
      onCancel={handleCancel}
      footer={[
        <Tooltip
          key="submit"
          title={disabled ? 'Cutoff for selected delivery date has passed. Page will refresh shortly.' : ''}
        >
          <Button className="btn-primary" onClick={onSubmit} loading={loading} disabled={disabled}>
            Yes, Confirm
          </Button>
        </Tooltip>,
      ]}
    >
      <div className="mb-3 flex flex-align-center">
        <IconBackground icon={<Receipt />} background="#E0EBF4" />
        <div className="ml-4 ff-medium fs-xs">Confirm Order</div>
      </div>
      <span className="ff-regular fs-xxs color-gray-1" style={{ letterSpacing: -0.3 }}>
        Are you sure you want to proceed with this order?
      </span>
    </Modal>
  );
};
